import { IReportingTypeService } from "../../service/reporting/ReportingTypeService";

export default class GetReportingTypeInteractor {
  private reportingTypeService: IReportingTypeService;

  constructor(reportingTypeService) {
    this.reportingTypeService = reportingTypeService;
  }

  async execute() {
    return this.reportingTypeService.getReportingTypes();
  }
}
